import React from "react";
import { AppStoreFR, FrankIcon, FrankIconForMobile } from "../../assets/images/FrankIcons";
import { defaultLabelColors } from "../../utils/constants";
import { SmoothCorners } from "react-smooth-corners";
import googlePlayBtn from "../../assets/mobileImages/french-google-play.png";

import mobile_res_img from "../../assets/images/FrankIcons/mobile_image_responsive.png";
import multiscreen from "../../assets/images/FrankIcons/mobile_resp_image_multi.png";
import iconThree from "../../assets/images/FrankIcons/assureThree.png";
import iconOne from "../../assets/images/FrankIcons/assureOne.png";
import iconTwo from "../../assets/images/FrankIcons/assureTwo.png";
import facebookIcon from "../../assets/images/facebokIcon.png";
import instaIcon from "../../assets/images/InstaIcon.png";
import linkedInIcon from "../../assets/images/linkedInIcon.png";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useNavigate } from "react-router-dom";

function MobileResponsive(props: any) {
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {}
  );
  const navigate = useNavigate();
  const { classes } = props;

  const handleExpanded = (state_name: any) => {
    try {
      setState({ [state_name]: !state?.[state_name] });
    } catch (error) {}
  };
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let doc = document.getElementById("parallax_mobile");
      if (!doc) {
        return;
      }
      if (scrollTop >= 10) {
        doc.style.transform = `translateY(-${scrollTop / 2}px)`;
      } else {
        doc.style.transform = `translateY(0px)`;
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // React.useEffect(() => {
  //   const subscribe = window.addEventListener("scroll", (event) => {
  //     console.log(document.documentElement.scrollHeight);
  //   });

  //   return subscribe;
  // }, []);

  return (
    <>
      <div
        className={classes?.display_flex_center}
        style={{
          background: defaultLabelColors.main_background_new,
          padding: "16px 24px",
         
        }}
      >
        <div style={{ display: "flex", justifyContent: "center",height:'50px' }}>
          <FrankIconForMobile
           
          />
        </div>

        <div
          style={{
            // width: "100%",
            background: defaultLabelColors.main_orange_new,
            height: "676px",
            borderRadius: "24px",
            textAlign: "center",
            padding: "64px 24px 0px 24px",
            position: "relative",
            border: "3px solid #FFBB9E",
            display:'flex',justifyContent:'flex-start',
            alignItems:'center',
            flexDirection:'column'
          }}
        >
          <h2
            style={{
              color: defaultLabelColors.white,
              fontSize: "32px",
              fontFamily: "montserrat-Bold",
              margin: 0,
            }}
          >
            Envoyez vos colis entre particuliers
          </h2>
          <p
            style={{
              fontFamily: "montserrat-Medium",
              fontSize: "18px",
              color: defaultLabelColors.white,
              textAlign: "center",
            }}
          >
            Réduisez l’impact de vos envois.
            <br /> Grâce à Frank, des particuliers
            <br /> transportent vos objets <br /> sur leurs trajets !
          </p>
          <div style={{ display: "flex", justifyContent: "center",gap:18 }}>
            <a
              rel="noopener noreferrer"
              href="https://apps.apple.com/us/app/frank/id6502341979"
              target="_blank"
              style={{ width: 120  }}
            >
              {/* <AppStoreFR /> */}
              <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="120" height="40" rx="6" fill="black"/>
<path d="M24.7045 20.763C24.7166 19.8431 24.9669 18.9411 25.4321 18.141C25.8972 17.3409 26.5621 16.6687 27.3648 16.1869C26.8548 15.4758 26.1821 14.8907 25.4 14.4779C24.6178 14.065 23.7479 13.836 22.8592 13.8088C20.9635 13.6146 19.1258 14.9163 18.1598 14.9163C17.1751 14.9163 15.6878 13.8281 14.0862 13.8603C13.0502 13.893 12.0406 14.1871 11.1557 14.714C10.2708 15.2408 9.54075 15.9825 9.03674 16.8668C6.85352 20.5571 8.48201 25.9808 10.5734 28.9639C11.6197 30.4246 12.8426 32.0562 14.4428 31.9984C16.0086 31.9349 16.5934 31.0235 18.4835 31.0235C20.3561 31.0235 20.9048 31.9984 22.5374 31.9616C24.2176 31.9349 25.2762 30.4944 26.2859 29.0198C27.0377 27.979 27.6162 26.8287 28 25.6115C27.0238 25.2084 26.1908 24.5337 25.6048 23.6715C25.0187 22.8093 24.7056 21.7977 24.7045 20.763Z" fill="white"/>
<path d="M21.6201 11.8471C22.5362 10.7734 22.9875 9.39335 22.8782 8C21.4786 8.14352 20.1857 8.7966 19.2572 9.82911C18.8033 10.3335 18.4556 10.9203 18.234 11.556C18.0125 12.1917 17.9215 12.8638 17.9661 13.5338C18.6662 13.5408 19.3588 13.3927 19.9917 13.1005C20.6246 12.8084 21.1814 12.3798 21.6201 11.8471Z" fill="white"/>
<path d="M38.9487 15H37.9512V9.854H36.1978V9.00146H40.7065V9.854H38.9487V15ZM42.4424 9.60791L43.4883 8.05225H44.3936L43.1675 9.60791H42.4424ZM42.9521 15.0791C41.6865 15.0791 40.8999 14.3013 40.8999 12.9917V12.3633C40.8999 11.0449 41.7612 10.2759 42.895 10.2759C44.0596 10.2759 44.8813 11.0845 44.8813 12.3633V12.9082H41.8667V13.1367C41.8667 13.8047 42.2622 14.2969 42.9478 14.2969C43.4575 14.2969 43.8091 14.0552 43.875 13.7651H44.8286C44.7715 14.3013 44.2046 15.0791 42.9521 15.0791ZM41.8667 12.271H43.9277V12.2095C43.9277 11.5107 43.519 11.0449 42.8994 11.0449C42.2798 11.0449 41.8667 11.5107 41.8667 12.2095V12.271ZM46.1426 15V8.68506H47.1182V15H46.1426ZM49.9395 9.60791L50.9854 8.05225H51.8906L50.6646 9.60791H49.9395ZM50.4492 15.0791C49.1836 15.0791 48.397 14.3013 48.397 12.9917V12.3633C48.397 11.0449 49.2583 10.2759 50.3921 10.2759C51.5566 10.2759 52.3784 11.0845 52.3784 12.3633V12.9082H49.3638V13.1367C49.3638 13.8047 49.7593 14.2969 50.4448 14.2969C50.9546 14.2969 51.3062 14.0552 51.3721 13.7651H52.3257C52.2686 14.3013 51.7017 15.0791 50.4492 15.0791ZM49.3638 12.271H51.4248V12.2095C51.4248 11.5107 51.0161 11.0449 50.3965 11.0449C49.7769 11.0449 49.3638 11.5107 49.3638 12.2095V12.271ZM53.3892 13.0005V12.3281C53.3892 11.0845 54.1626 10.2759 55.3931 10.2759C56.5796 10.2759 57.2212 11.0054 57.2432 11.7964H56.3203C56.2808 11.502 56.061 11.0889 55.415 11.0889C54.7339 11.0889 54.3691 11.5811 54.3691 12.3501V13.0005C54.3691 13.7827 54.7603 14.2705 55.4194 14.2705C56.0391 14.2705 56.2808 13.9761 56.3467 13.6069H57.2695C57.2432 14.3936 56.6411 15.0791 55.3931 15.0791C54.1538 15.0791 53.3892 14.2837 53.3892 13.0005ZM58.4692 15V8.68506H59.4404V11.1899H59.4888C59.5898 10.8604 59.9678 10.2847 60.8994 10.2847C61.8047 10.2847 62.4507 10.8076 62.4507 11.8667V15H61.4795V12.1523C61.4795 11.4448 61.0884 11.1152 60.5347 11.1152C59.8359 11.1152 59.4404 11.6646 59.4404 12.4204V15H58.4692ZM65.1621 15.0703C64.2612 15.0703 63.6416 14.5166 63.6416 13.6509C63.6416 12.8291 64.2129 12.2754 65.2852 12.2754H66.4585V11.8403C66.4585 11.3086 66.1201 11.0581 65.584 11.0581C65.0566 11.0581 64.8193 11.2778 64.7446 11.5854H63.8174C63.8745 10.8076 64.459 10.2847 65.6147 10.2847C66.6079 10.2847 67.4297 10.6978 67.4297 11.8535V15H66.5024V14.3979H66.4585C66.252 14.7539 65.8477 15.0703 65.1621 15.0703ZM65.4653 14.3145C66.019 14.3145 66.4585 13.9365 66.4585 13.4312V12.9302H65.439C64.8721 12.9302 64.6216 13.2158 64.6216 13.6025C64.6216 14.0859 65.0259 14.3145 65.4653 14.3145ZM68.937 15V10.355H69.9082V11.0801H69.9609C70.062 10.7681 70.4004 10.2891 71.1782 10.2891C71.3101 10.2891 71.4155 10.2979 71.5078 10.3154V11.1768C71.4243 11.1548 71.2529 11.1416 71.0903 11.1416C70.3081 11.1416 69.9258 11.6074 69.9258 12.2358V15H68.937ZM74.2544 15.936C75.0059 15.936 75.3706 15.5361 75.3706 14.8506V14.187H75.3179C75.1421 14.5913 74.6675 14.9121 74.0171 14.9121C72.9932 14.9121 72.2197 14.1826 72.2197 12.9126V12.3018C72.2197 11.0317 72.9888 10.2935 74.0171 10.2935C74.7026 10.2935 75.1948 10.667 75.3486 11.0625H75.397V10.355H76.3418V14.8813C76.3418 16.1821 75.3882 16.7007 74.2236 16.7007C72.9712 16.7007 72.3735 16.0811 72.3208 15.3867H73.2876C73.3491 15.6987 73.7051 15.936 74.2544 15.936ZM74.3203 11.0933C73.6392 11.0933 73.2129 11.6162 73.2129 12.4204V12.8247C73.2129 13.6289 73.6743 14.1475 74.3291 14.1475C74.9971 14.1475 75.3706 13.5938 75.3706 12.9346V12.3237C75.3706 11.6514 74.9751 11.0933 74.3203 11.0933ZM79.6465 15.0791C78.3809 15.0791 77.5942 14.3013 77.5942 12.9917V12.3633C77.5942 11.0449 78.4556 10.2759 79.5894 10.2759C80.7539 10.2759 81.5757 11.0845 81.5757 12.3633V12.9082H78.561V13.1367C78.561 13.8047 78.9565 14.2969 79.6421 14.2969C80.1519 14.2969 80.5034 14.0552 80.5693 13.7651H81.5229C81.4658 14.3013 80.8989 15.0791 79.6465 15.0791ZM78.561 12.271H80.6221V12.2095C80.6221 11.5107 80.2134 11.0449 79.5938 11.0449C78.9741 11.0449 78.561 11.5107 78.561 12.2095V12.271ZM82.8677 15V10.355H83.8389V11.0801H83.8916C83.9927 10.7681 84.3311 10.2891 85.1089 10.2891C85.2407 10.2891 85.3462 10.2979 85.4385 10.3154V11.1768C85.355 11.1548 85.1836 11.1416 85.021 11.1416C84.2388 11.1416 83.8564 11.6074 83.8564 12.2358V15H82.8677ZM90.0264 10.2935C90.6812 10.2935 91.1821 10.5835 91.3623 11.0537H91.4106V8.68506H92.3862V15H91.437V14.2573H91.3887C91.248 14.7275 90.6899 15.0615 90.0132 15.0615C88.9453 15.0615 88.251 14.3013 88.251 13.0752V12.2798C88.251 11.0537 88.9585 10.2935 90.0264 10.2935ZM90.2988 11.0933C89.6484 11.0933 89.2441 11.5767 89.2441 12.4204V12.9302C89.2441 13.7783 89.6528 14.2617 90.3208 14.2617C90.98 14.2617 91.4106 13.7827 91.4106 12.9917V12.2886C91.4106 11.5723 90.9404 11.0933 90.2988 11.0933ZM95.1416 15.0703C94.2407 15.0703 93.6211 14.5166 93.6211 13.6509C93.6211 12.8291 94.1924 12.2754 95.2646 12.2754H96.438V11.8403C96.438 11.3086 96.0996 11.0581 95.5635 11.0581C95.0361 11.0581 94.7988 11.2778 94.7241 11.5854H93.7969C93.854 10.8076 94.4385 10.2847 95.5942 10.2847C96.5874 10.2847 97.4092 10.6978 97.4092 11.8535V15H96.4819V14.3979H96.438C96.2314 14.7539 95.8271 15.0703 95.1416 15.0703ZM95.4448 14.3145C95.9985 14.3145 96.438 13.9365 96.438 13.4312V12.9302H95.4185C94.8516 12.9302 94.6011 13.2158 94.6011 13.6025C94.6011 14.0859 95.0054 14.3145 95.4448 14.3145ZM98.855 15V10.355H99.813V11.1899H99.8613C99.98 10.8252 100.318 10.2847 101.259 10.2847C102.195 10.2847 102.823 10.8032 102.823 11.8623V15H101.848V12.1479C101.848 11.4404 101.479 11.1152 100.929 11.1152C100.208 11.1152 99.8306 11.6689 99.8306 12.4204V15H98.855ZM104.071 11.7085C104.071 10.6978 104.924 10.2759 105.869 10.2759C106.888 10.2759 107.587 10.7856 107.587 11.6074H106.708C106.682 11.3042 106.405 10.9878 105.842 10.9878C105.346 10.9878 105.007 11.2207 105.007 11.6206C105.007 12.1348 105.667 12.2051 106.181 12.293C107.046 12.4424 107.714 12.7192 107.714 13.5981C107.714 14.5342 106.972 15.0791 105.794 15.0791C104.691 15.0791 103.983 14.5825 103.983 13.752H104.933C104.985 14.1255 105.253 14.3672 105.842 14.3672C106.497 14.3672 106.765 14.0728 106.765 13.7124C106.765 13.229 106.233 13.1499 105.609 13.0312C104.761 12.8555 104.071 12.6182 104.071 11.7085Z" fill="white"/>
<path d="M37.2285 31V19.0718H39.0713V31H37.2285ZM42.0378 23.8364H40.6599L41.299 19.6694H43.092L42.0378 23.8364ZM43.7343 31H41.8168L45.7182 19.6694H47.8266L51.7197 31H49.7275L48.7231 27.8623H44.747L43.7343 31ZM46.7807 21.6284H46.706L45.1704 26.418H48.2997L46.7807 21.6284ZM56.9855 31.1245C55.8483 31.1245 54.985 30.585 54.5202 29.7798H54.4538V33.9136H52.611V22.2261H54.404V23.5127H54.4704C54.9518 22.6743 55.8483 22.1099 57.027 22.1099C58.9943 22.1099 60.3971 23.5957 60.3971 26.2188V26.999C60.3971 29.6055 59.0109 31.1245 56.9855 31.1245ZM56.5622 29.6055C57.7326 29.6055 58.5295 28.6675 58.5295 26.8994V26.2852C58.5295 24.5835 57.7824 23.6123 56.529 23.6123C55.2423 23.6123 54.4372 24.6582 54.4372 26.2769V26.8994C54.4372 28.5596 55.2506 29.6055 56.5622 29.6055ZM66.327 31.1245C65.1898 31.1245 64.3265 30.585 63.8617 29.7798H63.7953V33.9136H61.9525V22.2261H63.7455V23.5127H63.8119C64.2933 22.6743 65.1898 22.1099 66.3685 22.1099C68.3358 22.1099 69.7387 23.5957 69.7387 26.2188V26.999C69.7387 29.6055 68.3524 31.1245 66.327 31.1245ZM65.9037 29.6055C67.0741 29.6055 67.871 28.6675 67.871 26.8994V26.2852C67.871 24.5835 67.1239 23.6123 65.8705 23.6123C64.5839 23.6123 63.7787 24.6582 63.7787 26.2769V26.8994C63.7787 28.5596 64.5922 29.6055 65.9037 29.6055ZM73.5052 27.854H75.348C75.431 28.8335 76.2943 29.6719 77.8963 29.6719C79.3655 29.6719 80.2371 28.9829 80.2371 27.9121C80.2371 27.0488 79.6561 26.584 78.4442 26.2935L76.5848 25.8286C75.1238 25.4883 73.8123 24.6167 73.8123 22.7739C73.8123 20.6074 75.7049 19.4204 77.9046 19.4204C80.1043 19.4204 81.9388 20.6074 81.9803 22.7241H80.1707C80.0877 21.7612 79.3489 20.9644 77.8797 20.9644C76.5848 20.9644 75.7049 21.5786 75.7049 22.6328C75.7049 23.3716 76.2196 23.9028 77.2738 24.1436L79.1248 24.6001C80.8265 25.0151 82.1214 25.8203 82.1214 27.7461C82.1214 29.9707 80.3201 31.2241 77.7552 31.2241C74.6009 31.2241 73.5467 29.3813 73.5052 27.854ZM84.3409 22.2261V20.0928H86.1504V22.2261H87.8604V23.7036H86.1504V28.3853C86.1504 29.3398 86.5074 29.6055 87.4952 29.6055C87.6529 29.6055 87.8023 29.6055 87.9102 29.5889V31C87.7608 31.0249 87.4121 31.0581 87.0386 31.0581C84.9053 31.0581 84.316 30.2944 84.316 28.5347V23.7036H83.104V22.2261H84.3409ZM92.8108 22.0767C95.3342 22.0767 96.7039 23.853 96.7039 26.2437V26.9492C96.7039 29.4229 95.3425 31.1494 92.8108 31.1494C90.2791 31.1494 88.9011 29.4229 88.9011 26.9492V26.2437C88.9011 23.8613 90.2874 22.0767 92.8108 22.0767ZM92.8108 23.5542C91.4412 23.5542 90.7605 24.6748 90.7605 26.2686V26.9409C90.7605 28.5098 91.4329 29.6636 92.8108 29.6636C94.1887 29.6636 94.8528 28.5181 94.8528 26.9409V26.2686C94.8528 24.6665 94.1804 23.5542 92.8108 23.5542ZM98.2344 31V22.2261H100.077V23.3799H100.144C100.368 22.832 101.023 22.1016 102.244 22.1016C102.484 22.1016 102.692 22.1182 102.866 22.1514V23.7783C102.708 23.7368 102.385 23.7119 102.078 23.7119C100.6 23.7119 100.102 24.625 100.102 25.8037V31H98.2344ZM107.31 31.1494C104.961 31.1494 103.467 29.5972 103.467 26.999V26.1108C103.467 23.6621 104.928 22.0767 107.236 22.0767C109.576 22.0767 110.988 23.7202 110.988 26.1938V27.0322H105.285V27.2397C105.285 28.7173 106.082 29.6968 107.335 29.6968C108.273 29.6968 108.912 29.2319 109.136 28.4766H110.888C110.622 29.896 109.477 31.1494 107.31 31.1494ZM105.285 25.7456H109.186V25.729C109.186 24.4839 108.414 23.5044 107.244 23.5044C106.057 23.5044 105.285 24.4839 105.285 25.729V25.7456Z" fill="white"/>
</svg>

            </a>
            <a
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.frankc2c"
              target="_blank"
              style={{ width: 120 }}
            >
              {/* <img
                src={googlePlayBtn}
                style={{ height: "43px", width: "140px" }}
                alt="google-play"
              /> */}
              <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="120" height="40" rx="6" fill="black"/>
<path d="M17.8051 19.4617L8.08984 30.0059C8.09076 30.0078 8.09076 30.0106 8.09167 30.0125C8.39005 31.1574 9.41203 32 10.6256 32C11.1111 32 11.5664 31.8656 11.957 31.6305L11.988 31.6118L22.9232 25.1593L17.8051 19.4617Z" fill="#EA4335"/>
<path d="M27.6332 17.6642L27.624 17.6577L22.9029 14.8593L17.584 19.6994L22.922 25.1562L27.6177 22.3858C28.4407 21.9305 29.0001 21.0431 29.0001 20.0204C29.0001 19.0033 28.4489 18.1205 27.6332 17.6642Z" fill="#FBBC04"/>
<path d="M8.08942 9.9952C8.03102 10.2154 8 10.4468 8 10.6857V29.3182C8 29.5571 8.03102 29.7885 8.09034 30.0078L18.1386 19.7332L8.08942 9.9952Z" fill="#4285F4"/>
<path d="M17.8771 20L22.9049 14.8594L11.9825 8.3836C11.5856 8.14005 11.122 8.00009 10.6265 8.00009C9.41295 8.00009 8.38914 8.84456 8.09076 9.99043C8.09076 9.99136 8.08984 9.9923 8.08984 9.99323L17.8771 20Z" fill="#34A853"/>
<path d="M36.648 14.5V8.056H38.619C39.603 8.056 40.392 8.353 40.986 8.947C41.586 9.541 41.886 10.318 41.886 11.278C41.886 12.244 41.586 13.024 40.986 13.618C40.392 14.206 39.603 14.5 38.619 14.5H36.648ZM37.476 8.848V13.708H38.619C39.369 13.708 39.96 13.495 40.392 13.069C40.824 12.637 41.04 12.04 41.04 11.278C41.04 10.522 40.824 9.928 40.392 9.496C39.96 9.064 39.369 8.848 38.619 8.848H37.476ZM43.6987 14.5H42.8707V8.056H43.6987V14.5ZM48.9756 12.781C48.9756 13.345 48.7686 13.798 48.3546 14.14C47.9346 14.476 47.4246 14.644 46.8246 14.644C46.2906 14.644 45.8196 14.488 45.4116 14.176C45.0036 13.864 44.7216 13.438 44.5656 12.898L45.3576 12.574C45.4116 12.766 45.4866 12.94 45.5826 13.096C45.6786 13.252 45.7896 13.387 45.9156 13.501C46.0476 13.609 46.1916 13.696 46.3476 13.762C46.5036 13.822 46.6686 13.852 46.8426 13.852C47.2206 13.852 47.5296 13.756 47.7696 13.564C48.0096 13.366 48.1296 13.105 48.1296 12.781C48.1296 12.511 48.0306 12.28 47.8326 12.088C47.6466 11.902 47.2986 11.722 46.7886 11.548C46.2726 11.362 45.9516 11.236 45.8256 11.17C45.1416 10.822 44.7996 10.309 44.7996 9.631C44.7996 9.157 44.9886 8.752 45.3666 8.416C45.7506 8.08 46.2216 7.912 46.7796 7.912C47.2716 7.912 47.6976 8.038 48.0576 8.29C48.4176 8.536 48.6576 8.845 48.7776 9.217L48.0036 9.541C47.9316 9.301 47.7876 9.103 47.5716 8.947C47.3616 8.785 47.1036 8.704 46.7976 8.704C46.4736 8.704 46.2006 8.794 45.9786 8.974C45.7566 9.142 45.6456 9.361 45.6456 9.631C45.6456 9.853 45.7326 10.045 45.9066 10.207C46.0986 10.369 46.5156 10.561 47.1576 10.783C47.8116 11.005 48.2766 11.278 48.5526 11.602C48.8346 11.92 48.9756 12.313 48.9756 12.781ZM50.8002 11.89V14.5H49.9722V8.056H52.1682C52.7262 8.056 53.2002 8.242 53.5902 8.614C53.9862 8.986 54.1842 9.439 54.1842 9.973C54.1842 10.519 53.9862 10.975 53.5902 11.341C53.2062 11.707 52.7322 11.89 52.1682 11.89H50.8002ZM50.8002 8.848V11.098H52.1862C52.5162 11.098 52.7892 10.987 53.0052 10.765C53.2272 10.543 53.3382 10.279 53.3382 9.973C53.3382 9.673 53.2272 9.412 53.0052 9.19C52.7892 8.962 52.5162 8.848 52.1862 8.848H50.8002ZM61.2734 11.278C61.2734 12.232 60.9554 13.03 60.3194 13.672C59.6774 14.32 58.8914 14.644 57.9614 14.644C57.0254 14.644 56.2394 14.32 55.6034 13.672C54.9674 13.03 54.6494 12.232 54.6494 11.278C54.6494 10.324 54.9674 9.526 55.6034 8.884C56.2394 8.236 57.0254 7.912 57.9614 7.912C58.8974 7.912 59.6834 8.239 60.3194 8.893C60.9554 9.535 61.2734 10.33 61.2734 11.278ZM55.4954 11.278C55.4954 12.022 55.7294 12.637 56.1974 13.123C56.6714 13.609 57.2594 13.852 57.9614 13.852C58.6634 13.852 59.2484 13.609 59.7164 13.123C60.1904 12.643 60.4274 12.028 60.4274 11.278C60.4274 10.528 60.1904 9.913 59.7164 9.433C59.2484 8.947 58.6634 8.704 57.9614 8.704C57.2594 8.704 56.6714 8.947 56.1974 9.433C55.7294 9.919 55.4954 10.534 55.4954 11.278ZM63.0785 14.5H62.2505V8.056H63.2585L66.3905 13.069H66.4265L66.3905 11.827V8.056H67.2185V14.5H66.3545L63.0785 9.244H63.0425L63.0785 10.486V14.5ZM69.3451 14.5H68.5171V8.056H69.3451V14.5ZM70.6441 14.5V8.056H72.9751C73.4851 8.056 73.9231 8.224 74.2891 8.56C74.6551 8.89 74.8381 9.307 74.8381 9.811C74.8381 10.447 74.5471 10.894 73.9651 11.152V11.188C74.2951 11.296 74.5591 11.485 74.7571 11.755C74.9551 12.019 75.0541 12.322 75.0541 12.664C75.0541 13.192 74.8621 13.63 74.4781 13.978C74.1061 14.326 73.6471 14.5 73.1011 14.5H70.6441ZM71.4721 8.848V10.819H72.9751C73.2691 10.819 73.5151 10.72 73.7131 10.522C73.9111 10.318 74.0101 10.087 74.0101 9.829C74.0101 9.577 73.9141 9.349 73.7221 9.145C73.5301 8.947 73.2931 8.848 73.0111 8.848H71.4721ZM71.4721 11.593V13.708H73.1371C73.4371 13.708 73.6921 13.603 73.9021 13.393C74.1061 13.183 74.2081 12.934 74.2081 12.646C74.2081 12.364 74.1031 12.118 73.8931 11.908C73.6831 11.698 73.4191 11.593 73.1011 11.593H71.4721ZM79.6058 14.5H75.9878V8.056H76.8158V13.708H79.6058V14.5ZM84.2323 8.056V8.848H81.2983V10.891H83.9443V11.665H81.2983V13.708H84.2323V14.5H80.4703V8.056H84.2323ZM91.0313 12.781C91.0313 13.345 90.8243 13.798 90.4103 14.14C89.9903 14.476 89.4803 14.644 88.8803 14.644C88.3463 14.644 87.8753 14.488 87.4673 14.176C87.0593 13.864 86.7773 13.438 86.6213 12.898L87.4133 12.574C87.4673 12.766 87.5423 12.94 87.6383 13.096C87.7343 13.252 87.8453 13.387 87.9713 13.501C88.1033 13.609 88.2473 13.696 88.4033 13.762C88.5593 13.822 88.7243 13.852 88.8983 13.852C89.2763 13.852 89.5853 13.756 89.8253 13.564C90.0653 13.366 90.1853 13.105 90.1853 12.781C90.1853 12.511 90.0863 12.28 89.8883 12.088C89.7023 11.902 89.3543 11.722 88.8443 11.548C88.3283 11.362 88.0073 11.236 87.8813 11.17C87.1973 10.822 86.8553 10.309 86.8553 9.631C86.8553 9.157 87.0443 8.752 87.4223 8.416C87.8063 8.08 88.2773 7.912 88.8353 7.912C89.3273 7.912 89.7533 8.038 90.1133 8.29C90.4733 8.536 90.7133 8.845 90.8333 9.217L90.0593 9.541C89.9873 9.301 89.8433 9.103 89.6273 8.947C89.4173 8.785 89.1593 8.704 88.8533 8.704C88.5293 8.704 88.2563 8.794 88.0343 8.974C87.8123 9.142 87.7013 9.361 87.7013 9.631C87.7013 9.853 87.7883 10.045 87.9623 10.207C88.1543 10.369 88.5713 10.561 89.2133 10.783C89.8673 11.005 90.3323 11.278 90.6083 11.602C90.8903 11.92 91.0313 12.313 91.0313 12.781ZM94.2689 14.644C93.5549 14.644 92.9789 14.41 92.5409 13.942C92.1029 13.48 91.8839 12.868 91.8839 12.106V8.056H92.7119V12.142C92.7119 12.67 92.8499 13.087 93.1259 13.393C93.4019 13.699 93.7829 13.852 94.2689 13.852C94.7549 13.852 95.1359 13.699 95.4119 13.393C95.6879 13.087 95.8259 12.67 95.8259 12.142V8.056H96.6539V12.106C96.6539 12.886 96.4379 13.504 96.0059 13.96C95.5739 14.416 94.9949 14.644 94.2689 14.644ZM98.6303 8.848V11.116H99.9623C100.298 11.116 100.583 11.008 100.817 10.792C101.051 10.57 101.168 10.297 101.168 9.973C101.168 9.673 101.057 9.412 100.835 9.19C100.619 8.962 100.346 8.848 100.016 8.848H98.6303ZM98.6303 14.5H97.8023V8.056H99.9983C100.556 8.056 101.03 8.242 101.42 8.614C101.816 8.98 102.014 9.433 102.014 9.973C102.014 10.417 101.867 10.813 101.573 11.161C101.285 11.503 100.919 11.722 100.475 11.818L100.457 11.845L102.266 14.464V14.5H101.285L99.5483 11.89H98.6303V14.5Z" fill="white"/>
<path d="M93.5181 30.9097H95.1469V19.8981H93.5181V30.9097ZM108.189 23.8646L106.322 28.6388H106.266L104.328 23.8646H102.573L105.479 30.5371L103.823 34.249H105.521L110 23.8646H108.189ZM98.9519 29.6588C98.4176 29.6588 97.6739 29.3902 97.6739 28.7234C97.6739 27.8742 98.6001 27.5483 99.4005 27.5483C100.116 27.5483 100.454 27.7042 100.889 27.9165C100.762 28.9365 99.892 29.6588 98.9519 29.6588ZM99.1483 23.6241C97.969 23.6241 96.7469 24.1482 96.2424 25.3101L97.6879 25.9188C97.9969 25.3101 98.5721 25.111 99.1762 25.111C100.019 25.111 100.875 25.621 100.889 26.5283V26.6411C100.594 26.471 99.9627 26.2165 99.1902 26.2165C97.632 26.2165 96.0451 27.0806 96.0451 28.6952C96.0451 30.1689 97.323 31.1184 98.7546 31.1184C99.8501 31.1184 100.454 30.6225 100.833 30.0411H100.889V30.8912H102.461V26.6692C102.461 24.7146 101.015 23.6241 99.1483 23.6241ZM89.0821 25.2053H86.7655V21.4308H89.0821C90.2998 21.4308 90.9911 22.4482 90.9911 23.3176C90.9911 24.1711 90.2998 25.2053 89.0821 25.2053ZM89.0402 19.8981H85.1375V30.9097H86.7655V26.7379H89.0402C90.8453 26.7379 92.6199 25.4184 92.6199 23.3176C92.6199 21.2168 90.8453 19.8981 89.0402 19.8981ZM67.7583 29.6606C66.6332 29.6606 65.6913 28.7102 65.6913 27.4047C65.6913 26.0852 66.6332 25.1198 67.7583 25.1198C68.8695 25.1198 69.7406 26.0852 69.7406 27.4047C69.7406 28.7102 68.8695 29.6606 67.7583 29.6606ZM69.6289 24.4812H69.5722C69.2064 24.0417 68.5038 23.6444 67.6178 23.6444C65.7611 23.6444 64.0599 25.2898 64.0599 27.4047C64.0599 29.5047 65.7611 31.1369 67.6178 31.1369C68.5038 31.1369 69.2064 30.7396 69.5722 30.2851H69.6289V30.8251C69.6289 32.2582 68.8695 33.0246 67.6457 33.0246C66.6471 33.0246 66.0282 32.3005 65.7751 31.6901L64.3549 32.2864C64.7626 33.28 65.8458 34.5 67.6457 34.5C69.5582 34.5 71.1757 33.3646 71.1757 30.5978V23.8708H69.6289V24.4812ZM72.3008 30.9097H73.9323V19.8973H72.3008V30.9097ZM76.3362 27.277C76.2943 25.8298 77.4474 25.0916 78.2766 25.0916C78.9243 25.0916 79.4725 25.4176 79.6549 25.8862L76.3362 27.277ZM81.3989 26.028C81.0899 25.1912 80.1472 23.6444 78.2208 23.6444C76.3083 23.6444 74.7196 25.1621 74.7196 27.3907C74.7196 29.4906 76.2943 31.1369 78.4032 31.1369C80.1053 31.1369 81.0899 30.0869 81.4976 29.4765L80.2319 28.6247C79.8103 29.2493 79.2333 29.6606 78.4032 29.6606C77.5739 29.6606 76.983 29.2774 76.6033 28.5261L81.5674 26.4534L81.3989 26.028ZM41.8501 24.7939V26.383H45.6184C45.5058 27.277 45.2107 27.9297 44.7612 28.3834C44.2121 28.9374 43.3541 29.5479 41.8501 29.5479C39.5291 29.5479 37.7152 27.6602 37.7152 25.3189C37.7152 22.9767 39.5291 21.0899 41.8501 21.0899C43.1018 21.0899 44.0157 21.5867 44.6905 22.2254L45.8017 21.104C44.8589 20.1959 43.6081 19.5 41.8501 19.5C38.6719 19.5 36 22.1117 36 25.3189C36 28.5261 38.6719 31.1369 41.8501 31.1369C43.5653 31.1369 44.8589 30.5688 45.8715 29.5047C46.9129 28.4547 47.2358 26.9793 47.2358 25.7866C47.2358 25.4176 47.2079 25.0775 47.1512 24.7939H41.8501ZM51.5208 29.6606C50.3957 29.6606 49.425 28.7243 49.425 27.3907C49.425 26.0421 50.3957 25.1198 51.5208 25.1198C52.6451 25.1198 53.6158 26.0421 53.6158 27.3907C53.6158 28.7243 52.6451 29.6606 51.5208 29.6606ZM51.5208 23.6444C49.4669 23.6444 47.7936 25.2194 47.7936 27.3907C47.7936 29.5479 49.4669 31.1369 51.5208 31.1369C53.5739 31.1369 55.2472 29.5479 55.2472 27.3907C55.2472 25.2194 53.5739 23.6444 51.5208 23.6444ZM59.65 29.6606C58.5249 29.6606 57.5542 28.7243 57.5542 27.3907C57.5542 26.0421 58.5249 25.1198 59.65 25.1198C60.7752 25.1198 61.745 26.0421 61.745 27.3907C61.745 28.7243 60.7752 29.6606 59.65 29.6606ZM59.65 23.6444C57.597 23.6444 55.9237 25.2194 55.9237 27.3907C55.9237 29.5479 57.597 31.1369 59.65 31.1369C61.7031 31.1369 63.3764 29.5479 63.3764 27.3907C63.3764 25.2194 61.7031 23.6444 59.65 23.6444Z" fill="white"/>
</svg>

            </a>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "24px",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 6L12 11L17 6"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 13L12 18L17 13"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <p
              style={{
                fontFamily: "montserrat-Medium",
                fontSize: "16px",
                color: defaultLabelColors.white,
                textAlign: "center",
              }}
            >
              Découvrir Frank
            </p>
          </div>
          <div
            style={{
              transition: "all .3s linear",
              transformStyle: "preserve-3d",
              position: "absolute",
              zIndex: 99999,
              height:'100%',
              top:'50%'
            }}
            id="parallax_mobile"
          >
            <img
              src={mobile_res_img}
              alt="parallax background"
              style={{
                width: "100%",
                objectFit: "contain",
                height: "100%",
                transition: "1s",
                zIndex: 9999,
              }}
            />
          </div>
        </div>

        <div
          className={classes?.display_flex_center}
          style={{
            display: "flex",
            gap: 20,
            flexDirection: "column",
          }}
        >
          <h3
            style={{
              fontFamily: "montserrat-Bold",
              color: "#000",
              fontSize: "32px",
              textAlign: "center",
            }}
          >
            Pourquoi choisir
            <br />
            <span style={{ color: defaultLabelColors.main_orange_new }}>
              Frank ?
            </span>
          </h3>

          <SmoothCorners
            borderRadius={`16px !important`}
            corners="60%"
            style={{}}
            className="border-grey"
          >
            <div
              style={{
                background: defaultLabelColors.white,
                textAlign: "center",
                padding: 16,
                display: "flex",
                flexDirection: "column",
                gap: 10,
                borderRadius: 16,
              }}
            >
              <div
                className={classes?.display_flex_center}
                style={{ objectFit: "contain" }}
              >
                <img src={iconOne} style={{ height: 100, width: 86 }} alt="" />
              </div>
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    margin: 0,
                    fontFamily: "montserrat-SemiBold",
                    color: "#000",
                    fontSize: "24px",
                  }}
                >
                  Livraison{" "}
                  <span style={{ color: defaultLabelColors.main_orange_new }}>
                    {" "}
                    écologique{" "}
                  </span>
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontFamily: "montserrat-Medium",
                  }}
                >
                  Chaque colis livré par Frank, <br />
                  c'est 25kg de CO2 en moins
                </p>
              </div>
            </div>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`16px !important`}
            corners="60%"
            className="border-grey"
          >
            <div
              style={{
                background: defaultLabelColors.white,
                textAlign: "center",
                padding: 16,
                display: "flex",
                flexDirection: "column",
                gap: 10,
                borderRadius: 16,
              }}
            >
              <div
                className={classes?.display_flex_center}
                style={{ objectFit: "contain" }}
              >
                <img src={iconTwo} style={{ height: 100, width: 88 }} alt="" />
              </div>
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    margin: 0,
                    fontFamily: "montserrat-SemiBold",
                    color: "#000",
                    fontSize: "24px",
                  }}
                >
                  Livraison{" "}
                  <span style={{ color: defaultLabelColors.main_orange_new }}>
                    {" "}
                    économique{" "}
                  </span>
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontFamily: "montserrat-Medium",
                  }}
                >
                  Avec Frank, envoyez vos <br />
                  colis sans vous ruiner !
                </p>
              </div>
            </div>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`16px !important`}
            corners="60%"
            className="border-grey"
          >
            <div
              style={{
                background: defaultLabelColors.white,
                textAlign: "center",
                padding: 16,
                display: "flex",
                flexDirection: "column",
                gap: 10,
                borderRadius: 16,
              }}
            >
              <div
                className={classes?.display_flex_center}
                style={{ objectFit: "contain" }}
              >
                <img
                  src={iconThree}
                  style={{ height: 100, width: 79 }}
                  alt=""
                />
              </div>
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    margin: 0,
                    fontFamily: "montserrat-SemiBold",
                    color: "#000",
                    fontSize: "24px",
                  }}
                >
                  Livraison{" "}
                  <span style={{ color: defaultLabelColors.main_orange_new }}>
                    {" "}
                    assurée{" "}
                  </span>
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: "18px",
                    fontFamily: "montserrat-Medium",
                  }}
                >
                  Tous vos colis sont assurés <br />
                  lors de vos envois !
                </p>
              </div>
            </div>
          </SmoothCorners>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <a
              rel="noopener noreferrer"
              href="https://apps.apple.com/us/app/frank/id6502341979"
              target="_blank"
              style={{ width: 140, marginRight: "10px" }}
            >
              <AppStoreFR />
            </a>
            <a
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.frankc2c"
              target="_blank"
              style={{ width: 140 }}
            >
              <img
                src={googlePlayBtn}
                style={{ height: "43px", width: "140px" }}
                alt="google-play"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style={{
          background: "#fce6dd",
          borderRadius: 24,
          padding: "16px 24px",
          marginTop: "10px",
          display: "flex",
          flexDirection: "column",
          paddingBottom: "150px",
        }}
      >
        <div style={{}}>
          <h3
            style={{
              fontSize: 32,
              fontFamily: "montserrat-Bold",
              color: "#000",
              textAlign: "center",
            }}
          >
            La livraison
            <br />
            de particulier à <br /> particulier{" "}
            <span style={{ color: defaultLabelColors.main_orange_new }}>
              {" "}
              comment <br /> ça marche ?
            </span>
          </h3>
        </div>

        <div
          style={{
            position: "relative",
            borderRadius: "14px",
          }}
        >
          <img src={multiscreen} alt="" />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            marginTop: "-100px",
          }}
        >
          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            style={{ alignSelf: "center", minWidth: "80%",position:'relative',zIndex:9999 }}
            className="border-orange"
          >
            <div
              style={{
                borderRadius: "8px",
                background: defaultLabelColors.white,
                padding: "16px",
                alignSelf: "center",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div>
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5007 28.4154C22.6343 28.4154 28.4173 22.6324 28.4173 15.4987C28.4173 8.36502 22.6343 2.58203 15.5007 2.58203C8.36697 2.58203 2.58398 8.36502 2.58398 15.4987C2.58398 22.6324 8.36697 28.4154 15.5007 28.4154Z"
                      fill="#EF6A31"
                    />
                    <path
                      d="M10.334 15.4988L13.7784 19.0757L20.6673 11.9219"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  style={{
                    flex: 1,
                    fontSize: "18px",
                    fontFamily: "montserrat-SemiBold",
                    color: defaultLabelColors.main_orange_new,
                  }}
                >
                  Envoyer un colis ?
                </div>
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "16px",
                  color: "#000",
                  fontFamily: "montserrat-Medium",
                }}
              >
                Publiez votre annonce <br />
                en indiquant les détails <br /> concernant le colis <br /> et sa
                destination.
              </div>
            </div>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            style={{ alignSelf: "center", minWidth: "80%" }}
            className="border-orange"
          >
            <div
              style={{
                borderRadius: "10px",
                background: defaultLabelColors.white,
                padding: "16px",
                alignSelf: "center",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div>
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5007 28.4154C22.6343 28.4154 28.4173 22.6324 28.4173 15.4987C28.4173 8.36502 22.6343 2.58203 15.5007 2.58203C8.36697 2.58203 2.58398 8.36502 2.58398 15.4987C2.58398 22.6324 8.36697 28.4154 15.5007 28.4154Z"
                      fill="#EF6A31"
                    />
                    <path
                      d="M10.334 15.4988L13.7784 19.0757L20.6673 11.9219"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  style={{
                    flex: 1,
                    fontSize: "18px",
                    fontFamily: "montserrat-SemiBold",
                    color: defaultLabelColors.main_orange_new,
                  }}
                >
                  Transporter un colis ?
                </div>
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "16px",
                  color: "#000",
                  fontFamily: "montserrat-Medium",
                }}
              >
                Parcourez les offres <br /> de livraisons disponibles et <br />{" "}
                choisissez celles qui vous <br /> conviennent.
              </div>
            </div>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            style={{ alignSelf: "center", minWidth: "80%" }}
            className="border-orange"
          >
            <div
              style={{
                borderRadius: "10px",
                background: defaultLabelColors.white,
                padding: "16px",
                alignSelf: "center",
                gap: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div>
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5007 28.4154C22.6343 28.4154 28.4173 22.6324 28.4173 15.4987C28.4173 8.36502 22.6343 2.58203 15.5007 2.58203C8.36697 2.58203 2.58398 8.36502 2.58398 15.4987C2.58398 22.6324 8.36697 28.4154 15.5007 28.4154Z"
                      fill="#EF6A31"
                    />
                    <path
                      d="M10.334 15.4988L13.7784 19.0757L20.6673 11.9219"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>

                <div
                  style={{
                    flex: 1,
                    fontSize: "18px",
                    fontFamily: "montserrat-SemiBold",
                    color: "#000",
                  }}
                >
                  Le colis a été{" "}
                  <span style={{ color: defaultLabelColors.main_orange_new }}>
                    {" "}
                    livré !{" "}
                  </span>
                </div>
              </div>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "16px",
                  color: "#000",
                  fontFamily: "montserrat-Medium",
                }}
              >
                Félicitations ! <br />
                Votre porte-monnaie
                <br />
                se remplit automatiquement <br />
                une fois que la livraison
                <br />a été réalisée.
              </div>
            </div>
          </SmoothCorners>
        </div>
      </div>

      <div
        style={{
          background: defaultLabelColors.main_orange_new,
          borderRadius: 24,
          padding: "16px 24px",
          display: "flex",
          flexDirection: "column",
          marginTop: -20,
          position: "relative",
          zIndex: 111111,
        }}
      >
        <h3
          style={{
            fontFamily: "montserrat-Bold",
            color: defaultLabelColors.white,
            textAlign: "center",
            fontSize: 32,
          }}
        >
          FAQ
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
          >
            <Accordion
              elevation={0}
              style={{
                background: defaultLabelColors?.white,
                borderRadius: "8px",
                padding: "16px 0px",
              }}
              expanded={state?.expanded_1}
              onChange={() => handleExpanded("expanded_1")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                // expandIcon={<AddIcon style={{color:defaultLabelColors.main_orange_new}} />}
                expandIcon={
                  state?.expanded_1 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                } // Dynamic icon change
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  }, // Change h3 color when expanded
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 18,
                    color: defaultLabelColors.main_orange_new,
                    margin: 0,
                  }}
                >
                  Comment fonctionne la livraison collaborative ?{" "}
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                }}
              >
                Grâce à notre plateforme, un particulier peut envoyer un colis
                qui sera livré par un autre particulier lors d’un de ses trajets
                personnels. Au cœur de notre activité, la livraison
                collaborative nous permet de créer une communauté d’entraide en
                garantissant un service d’envoi peu coûteux et écologique.
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
          >
            <Accordion
              elevation={0}
              style={{
                border: "0px",
                background: defaultLabelColors?.white,
                borderRadius: "8px",
                padding: "16px 0px",
              }}
              expanded={state?.expanded_2}
              onChange={() => handleExpanded("expanded_2")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                // expandIcon={<AddIcon style={{color:defaultLabelColors.main_orange_new}} />}
                expandIcon={
                  state?.expanded_2 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                } // Dynamic icon change
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  }, // Change h3 color when expanded
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: "18px",
                    padding: "20px 0px",
                    color: defaultLabelColors.main_orange_new,
                  }}
                >
                  Comment fonctionne la livraison professionnelle avec Frank ?{" "}
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                }}
              >
                <p>
                  {" "}
                  Nous couvrons l’envoi du premier au dernier kilomètre et
                  stockons vos colis dans notre entrepôt en Île-de-France. En
                  fonction de vos besoins, nous proposons plusieurs modes de
                  livraison professionnelle :
                </p>

                <p>
                  {" "}
                  • Pick & Pack : récupération des colis à votre adresse,
                  préparation des colis, packaging d’envoi{" "}
                </p>
                <p>
                  {" "}
                  • Livraison totale : nous nous occupons de tout, de la
                  récupération des colis jusqu’à leur dépôt chez le client final{" "}
                </p>
                <p>
                  {" "}
                  • Stockage : nous stockons vos colis dans notre entrepôt en
                  Île-de-France, avant leur retrait
                </p>

                <p>
                  Pour plus d’informations, vous pouvez nous contacter en
                  envoyant un mail à l’adresse : hello@frankme.com
                </p>
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
          >
            <Accordion
              elevation={0}
              style={{
                border: "0px",
                borderRadius: "8px",
                background: defaultLabelColors?.white,
                padding: "16px 0px",
              }}
              expanded={state?.expanded_3}
              onChange={() => handleExpanded("expanded_3")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                expandIcon={
                  state?.expanded_3 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                }
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  },
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 18,
                    padding: "20px 0px",
                    color: defaultLabelColors.main_orange_new,
                  }}
                >
                  Puis-je gagner de l’argent avec Frank ?
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                }}
              >
                <p>
                  Vous êtes transporteur ? En voiture, en train, en trottinette,
                  en péniche ou à pied, quel que soit le mode de transport, vous
                  gagnez de l’argent
                  !ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                  ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                  <br></br>
                  Vous envoyez un colis avec Frank ? Vous ne gagnez pas
                  d’argent, mais vous en économisez à coup sûr !
                </p>
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
          >
            <Accordion
              elevation={0}
              style={{
                border: "0px",
                background: defaultLabelColors?.white,
                borderRadius: "8px",
                padding: "16px 0px",
              }}
              expanded={state?.expanded_4}
              onChange={() => handleExpanded("expanded_4")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                // expandIcon={<AddIcon style={{color:defaultLabelColors.main_orange_new}} />}
                expandIcon={
                  state?.expanded_4 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                } // Dynamic icon change
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  }, // Change h3 color when expanded
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 18,
                    color: defaultLabelColors.main_orange_new,
                    padding: "20px 0px",
                  }}
                >
                  Comment fonctionne l’assurance des colis ?{" "}
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                }}
              >
                Tout envoi de colis via Frank est assuré à une hauteur de 100 €.
                Pour vos colis les plus précieux, vous pouvez souscrire à une
                assurance supplémentaire (HISCOX).ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
          >
            <Accordion
              elevation={0}
              style={{
                border: "0px",
                background: defaultLabelColors?.white,
                width: "100%",
                borderRadius: "8px",
                padding: "16px 0px",
              }}
              expanded={state?.expanded_5}
              onChange={() => handleExpanded("expanded_5")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                // expandIcon={<AddIcon style={{color:defaultLabelColors.main_orange_new}} />}
                expandIcon={
                  state?.expanded_5 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                } // Dynamic icon change
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  }, // Change h3 color when expanded
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 18,
                    color: defaultLabelColors.main_orange_new,
                    padding: "20px 0px",
                  }}
                >
                  Comment devenir transporteur ?
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                }}
              >
                <p>
                  {" "}
                  Pour devenir transporteur à nos côtés, rien de plus simple :
                </p>

                <p>
                  {" "}
                  • Vous créez un compte sur le site ou l’application de Frank ;{" "}
                </p>
                <p>
                  {" "}
                  • Vous checkez les annonces à côté de vous, ou sur vos trajets
                  ;{" "}
                </p>
                <p> • Vous acceptez une offre ;</p>
                <p>
                  {" "}
                  • Vous remettez le colis au destinataire, qui vous remet un
                  code pour valider la livraison ;{" "}
                </p>
                <p>
                  {" "}
                  • Vous recevez le montant de la livraison sur votre
                  porte-monnaie une fois que vous avez renseigné le code.{" "}
                </p>
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
            style={{ height: "100% !important" }}
          >
            <Accordion
              elevation={0}
              style={{
                border: "0px",
                background: defaultLabelColors?.white,
                borderRadius: "8px",
                padding: "48px 0px",
                height: "100%",
              }}
              expanded={state?.expanded_6}
              onChange={() => handleExpanded("expanded_6")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                // expandIcon={<AddIcon style={{color:defaultLabelColors.main_orange_new}} />}
                expandIcon={
                  state?.expanded_6 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                } // Dynamic icon change
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  }, // Change h3 color when expanded
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-Semibold",
                    fontSize: 18,
                    padding: "20px 0px",
                    color: defaultLabelColors.main_orange_new,
                  }}
                >
                  En tant que transporteur, comment transférer l’argent de mon
                  porte-monnaie sur mon compte bancaire ?{" "}
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                  paddingTop: 32,
                }}
              >
                Sur l’application Frank, il y a un espace porte-monnaie, où vous
                trouverez le montant total de vos gains. Il suffit de cliquer
                sur la carte bancaire, puis sur “transférer sur un compte
                bancaire” et de renseigner les informations demandées. L’argent
                arrive sur votre compte au bout de quelques jours !
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <SmoothCorners
            borderRadius={`12px !important`}
            corners="60%"
            className="border-orange"
          >
            <Accordion
              elevation={0}
              style={{
                border: "0px",
                background: defaultLabelColors?.white,
                borderRadius: "8px",
                padding: "16px 0px",
              }}
              expanded={state?.expanded_7}
              onChange={() => handleExpanded("expanded_7")}
            >
              <AccordionSummary
                style={{ border: "none" }}
                // expandIcon={<AddIcon style={{color:defaultLabelColors.main_orange_new}} />}
                expandIcon={
                  state?.expanded_7 ? (
                    <RemoveIcon
                      style={{
                        color: defaultLabelColors?.main_orange_new,
                      }}
                    />
                  ) : (
                    <AddIcon
                      style={{ color: defaultLabelColors.main_orange_new }}
                    />
                  )
                } // Dynamic icon change
                className="faq-comments"
                sx={{
                  "&.Mui-expanded h3": {
                    color: defaultLabelColors?.main_orange_new,
                  }, // Change h3 color when expanded
                }}
              >
                <h3
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 18,
                    padding: "20px 0px",
                    color: defaultLabelColors.main_orange_new,
                  }}
                >
                  Y a-t-il une limite de poids pour la livraison des colis ?{" "}
                </h3>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  width: "90%",
                  fontFamily: "montserrat-Regular",
                  color: defaultLabelColors.main_orange_new,
                  fontSize: 16,
                }}
              >
                Il n’y a pas de limite de poids chez Frank. Pour un
                déménagement, vous pouvez prévoir le nombre de personnes dont
                vous avez besoin en renfort en fonction de la taille des
                meubles.
              </AccordionDetails>
            </Accordion>
          </SmoothCorners>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <a
              rel="noopener noreferrer"
              href="https://apps.apple.com/us/app/frank/id6502341979"
              target="_blank"
              style={{ width: 140, marginRight: "10px" }}
            >
              <AppStoreFR />
            </a>
            <a
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.frankc2c"
              target="_blank"
              style={{ width: 140 }}
            >
              <img
                src={googlePlayBtn}
                style={{ height: "43px", width: "140px" }}
                alt="google-play"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        style={{
          background: "#3026F0",
          marginTop: "-10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          padding: "41px 20px 32px 20px",
        }}
      >
        <p
          style={{
            fontFamily: "montserrat-Medium",
            color: "#FFFFFFD9",
            textAlign: "center",
            fontSize: 17,
          }}
        >
          Nous contacter
        </p>

        <div style={{ display: "flex", gap: "16px" }}>
          <p
            style={{
              fontFamily: "montserrat-Regular",
              color: "#FFFFFFD9",
              fontSize: "16px",
              textDecoration: "none",
            }}
          >
            <a
              style={{
                textDecoration: "none",
                color: "#FFFFFFD9",
                fontSize: "16px",
                fontFamily: "montserrat-Regular",
              }}
              href="mailto:hello@frankme.com"
            >
              hello@frankme.com
            </a>
          </p>
          <p
            style={{
              fontFamily: "montserrat-Regular",
              color: "#FFFFFFD9",
              fontSize: "16px",
              opacity: "85%",
              textDecoration: "none",
            }}
          >
            <a
              style={{ textDecoration: "none", color: "#FFFFFFD9" }}
              href="tel:+33607948055"
            >
              {" "}
              +33 6 07 94 80 55
            </a>
          </p>
          {/* <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular",margin:0,padding:0}} onClick={()=>{navigate("/privacy-policy")}}>Politique de confidentialité</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular",margin:0,padding:0}} onClick={()=>{navigate("/terms-and-condition")}}>Termes et conditions</li> */}
        </div>

        <div>
          <p
            style={{
              fontSize: "16px",
              color: "#FFFFFFD9",
              fontFamily: "montserrat-Regular",
              margin: 0,
              padding: 0,
              textAlign: "center",
            }}
            onClick={() => {
              navigate("/privacy-policy");
            }}
          >
            Politique de confidentialité
          </p>
          <p
            style={{
              fontSize: "16px",
              color: "#FFFFFFD9",
              fontFamily: "montserrat-Regular",
              margin: 0,
              padding: 0,
              textAlign: "center",
            }}
            onClick={() => {
              navigate("/terms-and-condition");
            }}
          >
            Termes et conditions
          </p>
        </div>

        <div
          className="col"
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 40,
            marginTop: "20px",
          }}
        >
          <p style={{ margin: 0 }}>
            <FrankIcon fill={"#fff"} height={80} />
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              flexDirection: "row",
              maxWidth: "129px",
              marginLeft: "40px",
              marginTop: "-50px",
              gap: 10,
            }}
          >
            <div
              onClick={() =>
                window.open(
                  "https://www.facebook.com/profile.php?id=61561661727623",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              style={{
                cursor: "pointer",
                display: "inline-flex", // Ensure the image fills the div
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={facebookIcon}
                alt="facebook-icon"
                style={{
                  width: "30px", // Make image fill the div
                  height: "30px", // Adjust height if needed
                  display: "block", // Remove gaps around the image
                  zIndex: "11111",
                }}
              />
            </div>

            <div
              onClick={() =>
                window.open(
                  "https://www.instagram.com/frankme.fr/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              style={{
                cursor: "pointer",
                display: "inline-flex", // Ensure the image fills the div
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={instaIcon}
                alt="facebook-icon"
                style={{
                  width: "30px", // Make image fill the div
                  height: "30px", // Adjust height if needed
                  display: "block", // Remove gaps around the image
                  zIndex: "11111",
                }}
              />
            </div>

            <div
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/company/fr-frank/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={linkedInIcon}
                alt="linkedin-icon"
                style={{
                  width: "30px", // Make image fill the div
                  height: "30px", // Adjust height if needed
                  display: "block", // Remove gaps around the image
                  zIndex: "11111",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileResponsive;
